import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addSpeakToTextChat, updateSpeakToTextsChat } from 'services';
import { AppDispatch } from 'store';
import { SpeakToTextDto } from 'types';
export function useActionsOmniSpeakToText(callSessionId: number, endpointNameMessages?: string) {
  const dispatch = useDispatch<AppDispatch>();

  const dispatchUpdateMessage = useCallback(
    (data: SpeakToTextDto, messageId: number) => {
      if (endpointNameMessages)
        dispatch(updateSpeakToTextsChat(data, messageId, endpointNameMessages, { callSessionId }));
    },
    [endpointNameMessages]
  );

  const dispatchAddMessage = useCallback(
    (data: SpeakToTextDto) => {
      if (endpointNameMessages) dispatch(addSpeakToTextChat(data, endpointNameMessages, { callSessionId }));
    },
    [endpointNameMessages]
  );

  const handleUpdateMessage = (message: SpeakToTextDto) => {
    dispatchUpdateMessage(
      {
        ...message
      },
      message.speakToTextId
    );
  };
  const handleAddMessage = (message: SpeakToTextDto) => {
    dispatchAddMessage({
      ...message
    });
  };

  return { handleUpdateMessage, handleAddMessage };
}
